import type { LogsEvent, LogsEventDomainContext } from "@datadog/browser-logs";

export function downgradeNetworkDropouts(
  log: LogsEvent,
  context: LogsEventDomainContext,
): boolean {
  if (log.origin !== "network" || log.http?.status_code !== 0) return true;
  log.status = "warn";
  log.http.is_aborted = (
    context as LogsEventDomainContext<"network">
  ).isAborted;
  return true;
}
